import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { ComprehensiveRequestsService } from "src/services/comprehensive-requests.service";
import { Lightbox } from "ngx-lightbox";
import { RateCard } from "src/models/rate-card";
import { OwlOptions } from "ngx-owl-carousel-o";
import { Helpers } from "src/helpers/helpers";
import { AccountService } from "src/services/account.service";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";

@Component({
  selector: "app-comprehensive-order-detail",
  templateUrl: "./comprehensive-order-detail.component.html",
  styleUrls: ["./comprehensive-order-detail.component.css"],
})
export class ComprehensiveOrderDetailComponent implements OnInit {
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
    },
    nav: false,
  };
  isAgencyUser: boolean = false;
  order?: RateCard;

  constructor(
    private lightbox: Lightbox,
    private route: ActivatedRoute,
    private _quoteService: ComprehensiveRequestsService,
    private sanitizer: DomSanitizer,
    private helper: Helpers,
    private accountService: AccountService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {
    const obj = this.helper.getDecodedAccessToken(
      localStorage.getItem("token")
    );
    if (
      obj.type.indexOf("LEVEL 0") === 0 ||
      obj.type.indexOf("LEVEL 1") === 0 ||
      obj.type.indexOf("LEVEL 2") === 0
    ) {
      this.isAgencyUser = true;
      this.accountService.getAccount().subscribe((data) => {
        if (!data.activated) {
          this.helper.logout();
          this.router.navigate(["/"]);
          this.snackBar.open(
            "Your account is not active, please contact admin.",
            "Close",
            {
              duration: 3000,
            }
          );
        }
      });
    }
  }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get("id");
    this.getOrder(id);
  }

  openCarImage(car: string): void {
    const src = car;
    const thumb = car;
    const album = {
      src,
      caption: "",
      thumb,
    };
    this.lightbox.open([album], 0);
  }

  getOrder(id: any) {
    this._quoteService.getQuoteRequestByVehicleId(id).subscribe((res) => {
      this.order = res;
      this.order.policyDocuments = this.order.policyDocuments.map(
        (document: string) => {
          return this.sanitizer.bypassSecurityTrustResourceUrl(document);
        }
      );
    });
  }
}
